import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleOff, Clock, HelpCircle } from 'lucide-react';
export function PainPoints() {
  const pains = [{
    icon: <MessageCircleOff className="w-8 h-8 text-gold mb-6" strokeWidth={1.5} data-id="element-103" />,
    text: 'El cliente desaparece después de la cotización'
  }, {
    icon: <Clock className="w-8 h-8 text-gold mb-6" strokeWidth={1.5} data-id="element-104" />,
    text: '"Lo voy a pensar" (y nunca más responden)'
  }, {
    icon: <HelpCircle className="w-8 h-8 text-gold mb-6" strokeWidth={1.5} data-id="element-105" />,
    text: 'No sabés cómo hacer seguimiento sin ser pesado'
  }];
  return <section className="bg-navy text-cream py-24 px-5" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-108">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy border border-gold/30 p-10 rounded flex flex-col items-center text-center hover:border-gold hover:bg-gold/5 transition-all duration-300" data-id="element-109">
              {pain.icon}
              <p className="font-playfair text-xl md:text-2xl font-medium leading-snug" data-id="element-110">
                {pain.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}